// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1___ec311a5f8c54d656f41","cls2":"AccountMenuButton-cls2___388e13d2ff5242b30f8 AccountMenuButton-cls1___ec311a5f8c54d656f41"};